module.exports = {
  createController: 'CREATE_CONTROLLER',
  widgetLoaded: 'WIDGET_LOADED',
};
